import { render, staticRenderFns } from "./LogicCardEChart.vue?vue&type=template&id=dda796b8&scoped=true"
import script from "./LogicCardEChart.vue?vue&type=script&lang=js"
export * from "./LogicCardEChart.vue?vue&type=script&lang=js"
import style0 from "./LogicCardEChart.vue?vue&type=style&index=0&id=dda796b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda796b8",
  null
  
)

export default component.exports